module.exports = __webpack_public_path__ + "static/img/Christmas_banner_bg1.f79c5b5.png";